"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5864],{

/***/ 45864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionNewsletter": function() { return /* binding */ SectionNewsletter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const ContentWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    border: "1px solid",
    borderRadius: "$r3",
    margin: "0 $32",
    padding: "$40",
    backgroundColor: "$techstackCardsBackground",
    variants: {
        theme: {
            light: {
                color: "$black",
                borderColor: "$socialsGray",
                backgroundColor: "$socialsGray"
            },
            dark: {
                color: "$white",
                borderColor: "$techstackCardsBackground",
                backgroundColor: "$techstackCardsBackground"
            }
        }
    }
});
const Heading = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("h2", {
    projectFont: "heading05",
    marginBottom: "$16"
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "heading08",
    marginBottom: "$20"
});
const Author = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    gridTemplate: "\n                'avatar details'\n                '. description'\n              ",
    alignItems: "center",
    gridTemplateColumns: "60px auto",
    gridRowGap: "$8",
    gridColumnGap: "$32",
    marginTop: "$96"
});
const Avatar = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    overflow: "hidden",
    borderRadius: "$rMax",
    width: 80,
    height: 80,
    gridArea: "avatar"
});
const Name = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body03"
});
const Position = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body03",
    variants: {
        theme: {
            light: {
                color: "$black_05"
            },
            dark: {
                color: "$white_05"
            }
        }
    }
});
const Details = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    gridArea: "details"
});
const StyledLink = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
    display: "inline-block",
    projectFont: "ui01",
    border: "1px solid $white_02",
    padding: "$12 $24",
    borderRadius: "$rMax",
    backgroundColor: "$white_02",
    textAlign: "center",
    variants: {
        theme: {
            light: {
                borderColor: "$black",
                color: "$black"
            },
            dark: {
                borderColor: "transparent",
                color: "$white"
            }
        }
    }
});
const SectionNewsletter = (param)=>{
    let { theme , title , description , authors , ctaLabel , ctaLink  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrapper, {
            theme: theme,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {
                    children: description
                }),
                ctaLink && ctaLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                    theme: theme,
                    ...ctaLink,
                    children: ctaLabel
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: authors && (authors === null || authors === void 0 ? void 0 : authors.map((author, index)=>{
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Author, {
                            as: (author === null || author === void 0 ? void 0 : author.linkedin) ? _portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU : "div",
                            href: author === null || author === void 0 ? void 0 : author.linkedin,
                            target: "_blank",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Avatar, {
                                    children: (author === null || author === void 0 ? void 0 : author.avatar) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                        ...author === null || author === void 0 ? void 0 : author.avatar,
                                        sizes: "80px"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Details, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Name, {
                                            children: author === null || author === void 0 ? void 0 : author.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Position, {
                                            theme: theme,
                                            children: author === null || author === void 0 ? void 0 : author.position
                                        })
                                    ]
                                }),
                                (author === null || author === void 0 ? void 0 : author.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
                                        value: author === null || author === void 0 ? void 0 : author.description,
                                        appearance: "plain"
                                    })
                                })
                            ]
                        }, "".concat(author === null || author === void 0 ? void 0 : author.name, "-").concat(index));
                    }))
                })
            ]
        })
    });
};


/***/ })

}]);